/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosportsStaggeredProductsListData } from './hosports-staggered-products-list.data';
import { IHosportsStaggeredProductsListProps } from './hosports-staggered-products-list.props.autogenerated';

export interface IHosportsStaggeredProductsListViewProps extends IHosportsStaggeredProductsListProps<IHosportsStaggeredProductsListData> {

}

/**
 *
 * HosportsStaggeredProductsList component
 * @extends {React.PureComponent<IHosportsStaggeredProductsListProps<IHosportsStaggeredProductsListData>>}
 */
class HosportsStaggeredProductsList extends React.PureComponent<IHosportsStaggeredProductsListProps<IHosportsStaggeredProductsListData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default HosportsStaggeredProductsList;
